'use strict';

/* globals define, $, socket, app, window, ajaxify, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/account/extended-settings', [
	'forum/account/header', 'components', 'translator', 'benchpress', 'pictureCropper', 'forum/account/edit', 'forum/account/settings'], function (
		header, components, translator, Benchpress, pictureCropper, accountEdit, accountSettings) {
	var settings = {};

	// If page skin is changed but not saved, switch the skin back
	$(window).on('action:ajaxify.start', function () {
		if (ajaxify.data.template.name === 'account/settings' && $('#bootswatchSkin').val() !== config.bootswatchSkin) {
			app.reskin(config.bootswatchSkin);
		}
	});

	settings.init = function () {
		header.init();

		settings.onNotificationOptionChanged();
		settings.getDeviceToken();

		accountEdit.initProfileFields();
		accountSettings.initSettingsFields('#settingsSubmitBtn');
	};

	settings.onNotificationOptionChanged = function () {
		$('.notification-setting').on('change', function () {
			var el = $(this);

			socket.emit('plugins.mobileSettings.changeNotificationSetting', { id: el.attr('id'), isChecked: el.is(':checked') }, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					title: 'Updated Categories',
					message: 'Changed!',
					type: 'success',
					timeout: 2000,
				});
			});
		});
	};

	settings.getDeviceToken = function () {
		$('#setDeviceTokenBtn').on('click', function () {
			socket.emit('plugins.mobileSettings.getDeviceToken', { }, function (err) {
				if (err) {
					return app.alertError(err.message);
				}
			});
		});
	};

	return settings;
});
